module.exports = __webpack_public_path__ + "static/media/single_room.c65f5f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/SingleRoom/images/single_room.jpg
// module id = 428
// module chunks = 0